import script from "./growth-contatos.vue?vue&type=script&setup=true&lang=js"
export * from "./growth-contatos.vue?vue&type=script&setup=true&lang=js"

import "./growth-contatos.vue?vue&type=style&index=0&id=64b27710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b27710"]])

export default __exports__